var map = {
	"./0.png": "d977",
	"./1.png": "0ca1",
	"./2.png": "b9af",
	"./3.png": "c2e4",
	"./4.png": "1105",
	"./5.png": "9310",
	"./amara-60.png": "7e31",
	"./amara-avatar.png": "42bc",
	"./amara-black-logo.png": "dcb6",
	"./amara-white-logo.png": "19cc",
	"./amara_avatar.png": "e8937",
	"./amara_logo.png": "e4b5",
	"./amara_logo_white.png": "9b83",
	"./crying.png": "51e1",
	"./dummy.png": "84f9",
	"./happy.png": "6d5d",
	"./image.png": "e429",
	"./in-love.png": "3aef",
	"./login.png": "07a6",
	"./logo.png": "cf05",
	"./negative.png": "e67b",
	"./noLogo.png": "bde6",
	"./sad.png": "b92b",
	"./shocked.png": "bad9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";